import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/core';
import { customMappingResultError } from '@lib/domain-common';
export var SEND_MESSAGE_USE_CASE = 'SEND_MESSAGE_USE_CASE';
export var SendMessageUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(SendMessageUseCase, _UseCase);

  var _super = _createSuper(SendMessageUseCase);

  function SendMessageUseCase(messageRepository, messageStreamingRepository) {
    var _this;

    _classCallCheck(this, SendMessageUseCase);

    _this = _super.call(this);
    _this.messageRepository = messageRepository;
    _this.messageStreamingRepository = messageStreamingRepository;
    return _this;
  }

  _createClass(SendMessageUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var _this$messageStreamin, unsubscribe, sendMessageResult, createdMessage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Subscribe BEFORE sending so the subscription is established
                // by the time the server starts streaming events.
                _this$messageStreamin = this.messageStreamingRepository.subscribeToConversation(input.conversationId, input.callbacks), unsubscribe = _this$messageStreamin.unsubscribe; // Artificial 1-second delay before sending the API request

                _context.next = 3;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 1000);
                });

              case 3:
                _context.next = 5;
                return this.messageRepository.sendMessage({
                  conversationId: input.conversationId,
                  content: input.content,
                  role: 'user',
                  data: input.data,
                  userId: input.userId,
                  modelId: input.modelId,
                  fileIds: input.fileIds || [],
                  resources: input.resources,
                  llmConfig: input.llmConfig || undefined
                });

              case 5:
                sendMessageResult = _context.sent;

                if (!sendMessageResult.isFailure) {
                  _context.next = 9;
                  break;
                }

                unsubscribe();
                return _context.abrupt("return", customMappingResultError(sendMessageResult));

              case 9:
                createdMessage = sendMessageResult.getValue();
                return _context.abrupt("return", Result.ok({
                  unsubscribe: unsubscribe,
                  messageId: createdMessage.id
                }));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return SendMessageUseCase;
}(UseCase);